const SUBSCRIPTION_STORAGE_KEY = "selectedSubscription";

export const getAzureSubscriptionId = () => {
  const subscriptionId = sessionStorage.getItem(SUBSCRIPTION_STORAGE_KEY);

  if (!subscriptionId || !subscriptionId.trim()) {
    throw new Error("Please select an Azure subscription before continuing.");
  }

  return subscriptionId;
};

export const getAzureFormDefaults = (formConfig) => {
  if (!formConfig.some(field => field.fieldName === "subscription_id")) {
    return {};
  }

  const subscriptionId = getAzureSubscriptionId();
  return {
    subscription_id: { value: subscriptionId, label: subscriptionId },
  };
};
